export default __webpack_public_path__ + "static/media/myImage.4a5ab825.jpg";